/* VIDA - Header: estados de scroll (transparente > cristal > oculto al bajar), progreso de lectura,
   mensajes rotativos, menu de productos y menu movil. El buscador vive en vida-search.js. */
(function () {
  'use strict';
  var header = document.querySelector('[data-v-header]');
  if (!header) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var overlay = header.hasAttribute('data-overlay');
  var smart = header.getAttribute('data-sticky') === 'smart';
  var bar = header.querySelector('[data-progress-bar]');
  var showProgress = header.hasAttribute('data-progress') && bar;

  /* ---------- Scroll ---------- */
  var lastY = window.scrollY, scrolled = false, ticking = false;
  function locked() {
    return header.classList.contains('is-mega-open') || document.body.classList.contains('v-lock');
  }
  function onScroll() {
    ticking = false;
    var y = Math.max(0, window.scrollY);
    // estado compacto / cristal
    if (overlay) {
      var s = y > 40;
      if (s !== scrolled) { scrolled = s; header.classList.toggle('is-scrolled', s); }
    }
    // ocultar al bajar, mostrar al subir
    if (smart && !locked()) {
      var dy = y - lastY;
      if (y > 320 && dy > 6) header.classList.add('is-hidden');
      else if (dy < -6 || y < 120) header.classList.remove('is-hidden');
    } else if (locked()) {
      header.classList.remove('is-hidden');
    }
    // progreso de lectura
    if (showProgress) {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.setProperty('--prog', max > 0 ? Math.min(1, y / max).toFixed(4) : 0);
    }
    lastY = y;
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  if (!overlay) header.classList.add('is-solid');
  // Si el hero es oscuro (foto o video a pantalla completa), el header usa texto claro hasta que se compacta
  if (overlay && document.querySelector('.v-hero--full')) header.classList.add('v-header--on-dark');
  onScroll();
  // Si el foco entra al header por teclado mientras esta oculto, lo mostramos
  header.addEventListener('focusin', function () { header.classList.remove('is-hidden'); });

  /* ---------- Mensajes superiores rotativos ---------- */
  var ann = header.querySelector('[data-ann][data-rotate]');
  if (ann && !reduce.matches) {
    var items = Array.prototype.slice.call(ann.querySelectorAll('.v-ann__item'));
    var cur = 0, paused = false;
    ann.addEventListener('mouseenter', function () { paused = true; });
    ann.addEventListener('mouseleave', function () { paused = false; });
    ann.addEventListener('focusin', function () { paused = true; });
    ann.addEventListener('focusout', function () { paused = false; });
    setInterval(function () {
      if (paused || document.hidden) return;
      var prev = items[cur];
      cur = (cur + 1) % items.length;
      prev.classList.remove('is-active'); prev.classList.add('is-out');
      setTimeout(function () { prev.classList.remove('is-out'); }, 600);
      items[cur].classList.add('is-active');
    }, 4800);
  }

  /* ---------- Menu de productos ---------- */
  var trigger = header.querySelector('[data-mega-trigger]');
  var panel = header.querySelector('[data-mega-panel]');
  if (trigger && panel) {
    var mItems = panel.querySelectorAll('[data-mega-item]');
    var cards = panel.querySelectorAll('[data-mega-card]');
    var closeTimer;
    function setActive(i) {
      mItems.forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-mega-item') === String(i)); });
      cards.forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-mega-card') === String(i)); });
    }
    function openMega() {
      clearTimeout(closeTimer);
      panel.hidden = false;
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
      trigger.setAttribute('aria-expanded', 'true');
      header.classList.add('is-mega-open'); header.classList.remove('is-hidden');
    }
    function closeMega() {
      panel.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      header.classList.remove('is-mega-open');
      closeTimer = setTimeout(function () { panel.hidden = true; }, 600);
    }
    var wrap = trigger.closest('.v-nav__item');
    if (window.matchMedia('(hover: hover)').matches) {
      wrap.addEventListener('mouseenter', openMega);
      header.addEventListener('mouseleave', function () { closeTimer = setTimeout(closeMega, 180); });
      panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    }
    trigger.addEventListener('click', function () { trigger.getAttribute('aria-expanded') === 'true' ? closeMega() : openMega(); });
    // Las imagenes del menu se piden al acercarse (evita retraso al cambiar de producto)
    function warm() { panel.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; }); }
    trigger.addEventListener('mouseenter', warm, { once: true });
    trigger.addEventListener('focus', warm, { once: true });
    // Teclado: flecha abajo abre y entra a la lista; flechas recorren los productos
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); openMega(); setTimeout(function () { if (mItems[0]) mItems[0].focus(); }, 60); }
    });
    panel.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var arr = Array.prototype.slice.call(mItems), i = arr.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      arr[(i + (e.key === 'ArrowDown' ? 1 : -1) + arr.length) % arr.length].focus();
    });
    mItems.forEach(function (el) {
      var i = el.getAttribute('data-mega-item');
      el.addEventListener('mouseenter', function () { setActive(i); });
      el.addEventListener('focus', function () { setActive(i); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && trigger.getAttribute('aria-expanded') === 'true') { closeMega(); trigger.focus(); } });
    document.addEventListener('click', function (e) { if (!header.contains(e.target) && trigger.getAttribute('aria-expanded') === 'true') closeMega(); });
    // cerrar el menu al abrir el buscador
    document.addEventListener('click', function (e) { if (e.target.closest('[data-search-open]') && trigger.getAttribute('aria-expanded') === 'true') closeMega(); });
  }

  /* ---------- Menu movil ---------- */
  var drawer = document.querySelector('[data-drawer]');
  var openBtn = header.querySelector('[data-drawer-open]');
  if (drawer && openBtn) {
    var closeBtn = drawer.querySelector('[data-drawer-close]');
    var hideTimer;
    function openDrawer() {
      clearTimeout(hideTimer);
      drawer.hidden = false;
      document.body.classList.add('v-lock');
      requestAnimationFrame(function () { requestAnimationFrame(function () { drawer.classList.add('is-open'); }); });
      openBtn.setAttribute('aria-expanded', 'true');
      closeBtn.focus({ preventScroll: true });
    }
    function closeDrawer(restoreFocus) {
      drawer.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      if (!document.querySelector('[data-search].is-open')) document.body.classList.remove('v-lock');
      hideTimer = setTimeout(function () { drawer.hidden = true; }, 1000);
      if (restoreFocus !== false) openBtn.focus({ preventScroll: true });
    }
    openBtn.addEventListener('click', openDrawer);
    closeBtn.addEventListener('click', function () { closeDrawer(); });
    document.addEventListener('vida:close-drawer', function () { if (drawer.classList.contains('is-open')) closeDrawer(false); });
    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') return closeDrawer();
      if (e.key === 'Tab') {
        var f = drawer.querySelectorAll('a[href], button');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    // Carrito desde el menu: cierra el menu y abre el carrito lateral
    var cartBtn = drawer.querySelector('[data-drawer-cart]');
    if (cartBtn) cartBtn.addEventListener('click', function () {
      closeDrawer(false);
      setTimeout(function () { var c = document.getElementById('cart-icon-bubble'); if (c) c.click(); }, reduce.matches ? 0 : 450);
    });
    // Gesto: deslizar hacia arriba en la parte superior cierra el menu (como recoger la cortina)
    var ty = null;
    drawer.addEventListener('touchstart', function (e) { ty = e.target.closest('.v-drawer__top') ? e.touches[0].clientY : null; }, { passive: true });
    drawer.addEventListener('touchend', function (e) {
      if (ty == null) return;
      if (ty - e.changedTouches[0].clientY > 60) closeDrawer();
      ty = null;
    }, { passive: true });
    drawer.querySelectorAll('[data-drawer-acc]').forEach(function (b) {
      b.addEventListener('click', function () {
        var li = b.closest('.v-drawer__item');
        var o = li.classList.toggle('is-open');
        b.setAttribute('aria-expanded', o ? 'true' : 'false');
      });
    });
    drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { document.body.classList.remove('v-lock'); }); });
    // al pasar a escritorio, limpiar el estado
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (m) { if (m.matches && drawer.classList.contains('is-open')) closeDrawer(false); });
  }
})();
